// Scroller
var $;

$.fn.scroller = function(options) {
	options = $.extend({
	target : window,
	items : function() {},
	calculation: function(pos) {},
	animation: function(pos) {},
	resize: function() {},
}, options);

Object.size = function(obj) {
		var size = 0, key;
		for (key in obj) {
				if (obj.hasOwnProperty(key)) size++;
		}
		return size;
};

var controller = {
		$this : $(this),
		loaded : false,
		RAF : {
			ID : null,
			start : null,
			stop : null,
			loop : null
		},
		scrollTimer : false,
		windowHeight : null,
	},
	pos = {
		current : {
			top : null,
			bottom : null,
		},
		previous : {
			top : null,
			bottom : null,
		},
		direction : null,
		total : 0,
		start : 0,
	},
	items = {},
	lockScroll = false;

function getTransform(transform) {
	return {
		'-webkit-transform': transform,
		'-moz-transform': transform,
		'-ms-transform': transform,
		'transform': transform
	};
}

var getItems = {
	default : function() {
		$.isFunction( options.items ) && options.items.call(controller.$this);
	},
	inview : function(opt) {
		if (options.inview == true) {
			if (typeof items.inview == 'undefined')	{
				items.inview = {};
			}
			if (typeof opt.item != 'object') {
				opt.item = $(opt.item);
			}
			opt.item.each(function() {
				var $this = $(this),
					key = Object.size(items.inview);
				items.inview[key] = {
					$this: $this,
					changed : false,
					cssClass: null,
					offset: $this.offset(),
					height: $this.outerHeight(),
					options : opt
				};
			});
			if (typeof items.inview[0] == 'undefined')	{
				options.inview = false;
			} else {
				options.inview = true;
			}
		}
	},
	anchors : function(opt) {
		if (options.anchors == true) {
			if (typeof items.anchors == 'undefined')	{
				items.anchors = {};
				controller.anchors = {
					current : null,
					changed : false,
						options : opt,
				};
			}
			if (typeof opt.item != 'object') {
				opt.item = $(opt.item);
			}
			opt.item.each(function() {
				var $this = $(this),
					key = Object.size(items.anchors);
				items.anchors[key] = {
					$this: $this,
					offset: $this.offset(),
					hash: $this.attr(opt.anchor),
					height: $this.outerHeight(),
					options : opt
				};
			});
			if (typeof items.anchors[0] == 'undefined')	{
				options.anchors = false;
			} else {
				options.anchors = true;
			}
		}
	},
	sticky : function(opt) {
		if (options.sticky == true) {
			if (typeof items.sticky == 'undefined')	{
				items.sticky = {};
			}
			if (typeof opt.item != 'object') {
				opt.item = $(opt.item);
			}
			if (opt.mode == 'sitewide') {
				opt.item.each(function() {
					var $this = $(this),
						key = Object.size(items.sticky);
					items.sticky[key] = {
						$this: $this,
						sticky : false,
						changed : false,
						options : opt,
					};
				});
			} else {
				opt.item.each(function() {
					var $this = $(this),
						key = Object.size(items.sticky);
					items.sticky[key] = {
						$this: $this,
						sticky : null,
						offset : $this.offset(),
						height : $this.outerHeight(),
						changed : false,
						transform : null,
						options : opt,
						end : null
					};
					if (items.sticky[key].$this.parent().is('body')) {
						items.sticky[key].offset.top = items.sticky[key].offset.top - $(options.target).scrollTop();
					}
					if (opt.end != false) {
						if (opt.end == 'parent') {
							items.sticky[key].end = $this.parent().offset().top + $this.parent().outerHeight();
						} else {
							if ( typeof opt.end != 'object' ) {
								opt.end = $(opt.end);
							}
							items.sticky[key].end = opt.end.offset().top;
						}
					}
				});
			}
			if (typeof items.sticky[0] == 'undefined')	{
				options.sticky = false;
			} else {
				options.sticky= true;
			}
		}
	}
};

var updateItems = {
	inview : function() {
		if (options.inview == true) {
			for (var key in items.inview) {
				var $item = items.inview[key];
				$item.changed = true;
				$item.cssClass = null;
				$item.offset = $item.$this.offset();
				$item.height = $item.$this.outerHeight();
			}
		}
	},
	anchors : function() {
		if (options.anchors == true) {
			for (var key in items.anchors) {
				var $item = items.anchors[key];
				$item.offset = $item.$this.offset();
				$item.height = $item.$this.outerHeight();
			}
			controller.anchors.current = false;
			controller.anchors.changed = true;
		}
	},
	sticky : function() {
		if (options.sticky == true) {
			for (var key in items.sticky) {
				var $item = items.sticky[key];
				if ($item.options.mode == 'sidebar') {
					$item.transform = getTransform('translate(0px, 0px)');
					$item.$this.css($item.transform).removeClass($item.options.cssClass);
					$item.offset = $item.$this.offset();
					$item.height = $item.$this.outerHeight();
					$item.sticky = null;
					$item.changed = true;
					$item.end = null;
					if ($item.$this.parent().is('body')) {
						// $item.offset.top = $item.offset.top - $(options.target).scrollTop();
					}
					if ($item.options.end != false) {
						if ($item.options.end == 'parent') {
							$item.end = $item.$this.parent().offset().top + $item.$this.parent().outerHeight();
						} else {
							$item.end = $item.options.end.offset().top;
						}
					}
				}
			}
		}
	}
};

var calculation = {
	default : function(pos) {
		$.isFunction( options.calculation ) && options.calculation.call(controller.$this, pos);
	},
	inview : function(pos) {
		if (options.inview == true) {
			for (var key in items.inview) {
				var $item = items.inview[key],
					viewbox = {
						top : pos.current.top + $item.options.offset.top,
						bottom : pos.current.bottom - $item.options.offset.bottom
					};
				if (($item.offset.top + $item.height) > viewbox.top && $item.offset.top < viewbox.bottom ) {
					if ($item.cssClass != 'inview') {
						$item.cssClass = 'inview';
						$item.changed = true;
					}
				} else if (($item.offset.top + $item.height) < viewbox.top) {
					if ($item.cssClass != 'above') {
						$item.cssClass = 'above';
						$item.changed = true;
					}
				} else {
					if ($item.cssClass != 'below') {
						$item.cssClass = 'below';
						$item.changed = true;
					}
				}
			}
		}
	},
	anchors : function(pos) {
		if (options.anchors == true) {
			var current;
			for (var key in items.anchors) {
				var $item = items.anchors[key],
					anchor = {
						top : $item.offset.top - $item.options.offset,
						bottom : $item.offset.top + $item.height - $item.options.offset
					};
				if (pos.direction == 'down' || pos.direction == null) {
					if (pos.current.top >= anchor.top) {
						current = $item.hash;
					}
				} else {
					if (pos.current.bottom >= anchor.bottom) {
						current = $item.hash;
					}
				}
			}
			if (controller.anchors.current != current) {
				controller.anchors.current = current;
				controller.anchors.changed = true;
			}
		}
	},
	sticky : function(pos) {
		if (options.sticky == true) {
			for (var key in items.sticky) {
				var $item = items.sticky[key];
				if ($item.options.mode == 'sitewide') {
					if (pos.current.top >= $item.options.start) {
						if($item.options.resetToTop != false && pos.direction == 'up' && Math.abs(pos.total) > $item.options.resetToTop) {
							if ($item.sticky != false) {
								$item.sticky = false;
								$item.changed = true;
							}
						} else if (pos.direction == 'down') {
							if ($item.sticky != true) {
								$item.sticky = true;
								$item.changed = true;
							}
						}
					} else {
						if ($item.sticky != false) {
							$item.sticky = false;
							$item.changed = true;
						}
					}
				} else {
					var point1 = $item.offset.top - $item.options.offset.top,
						point2 = $(document).height() + $(window).height();
					if ($item.end != null) {
						point2 = $item.end - $item.options.offset.bottom - $item.options.offset.top - $item.height;
					}
					if (pos.current.top < point1 ) {
						if ($item.sticky != false) {
							$item.sticky = false;
							$item.changed = true;
							$item.transform = getTransform('translate(0px, 0px)');
						}
					} else if (pos.current.top >= point1 && pos.current.top < point2) {
						if ($item.sticky != true) {
							$item.sticky = true;
							$item.changed = true;
							$item.transform = getTransform('translate(0px, '+$item.options.offset.top+'px)');
						}
					} else if (pos.current.top >= point2) {
						if ($item.sticky != false) {
							$item.sticky = false;
							$item.changed = true;
							var offset = point2 - point1;
							$item.transform = getTransform('translate(0px, '+offset+'px)');
						}
					}
				}
			}
		}
	}
};

var animation = {
	default : function() {
		$.isFunction( options.animation ) && options.animation.call(controller.$this, pos);
	},
	inview : function(pos) {
		if (options.inview == true) {
			for (var key in items.inview) {
				var $item = items.inview[key];
				if ($item.changed == true) {
					$item.changed = false;
					$.each(['inview', 'above', 'below'], function(i, v){
							$item.$this.removeClass(v);
						});
					$item.$this.addClass($item.cssClass);
					$.isFunction( $item.options.change ) && $item.options.change.call(controller.$this, $item, function(options) {
						if (options == 'delete') {
							delete items.inview[key];
						} else {
							var opt = $.extend(
								$item.options
							, options);
							$item.options = opt;
						}
					});
				}
			}
		}
	},
	anchors : function(pos) {
		if (options.anchors == true) {
			if (controller.anchors.changed == true) {
				controller.anchors.changed = false;
				if (controller.anchors.options.hash == true) {
					window.location.hash = controller.anchors.current;
				}
				$.isFunction( controller.anchors.options.change ) && controller.anchors.options.change.call(controller.$this, controller.anchors.current, function(options) {
					if (options == 'delete') {
						delete items.inview[key];
					} else {
						var opt = $.extend( $item.options, options);
						$item.options = opt;
					}
				});
			}
		}
	},
	sticky : function(pos) {
		if (options.sticky == true) {
			for (var key in items.sticky) {
				var $item = items.sticky[key];
				if ($item.changed == true) {
					$item.changed = false;
					if ($item.options.mode == 'sitewide') {
						if ($item.sticky == true) {
							$item.$this.addClass($item.options.cssClass);
						} else {
							$item.$this.removeClass($item.options.cssClass);
						}
					} else {
						if ($item.sticky == true) {
							$item.$this.addClass($item.options.cssClass).css($item.transform);
						} else {
							$item.$this.removeClass($item.options.cssClass).css($item.transform);
						}
					}
					$.isFunction( $item.options.change ) && $item.options.change.call(controller.$this, $item, function(options) {
						if (options == 'delete') {
							delete items.inview[key];
						} else {
							var opt = $.extend( $item.options, options);
							$item.options = opt;
						}
					});
				}
			}
		}
	}
};

function updatePos() {
	pos.current.top = Math.round($(options.target).scrollTop());
	if (pos.current.top < 0) { pos.current.top = 0; }
	pos.current.bottom = pos.current.top + controller.windowHeight;
	if (pos.current.top > pos.previous.top) {
		if (pos.direction != 'down') {
			pos.direction = 'down';
			pos.start = Math.round($(options.target).scrollTop());
		}
	} else if (pos.current.top < pos.previous.top) {
		if (pos.direction != 'up') {
			pos.direction = 'up';
			pos.start = Math.round($(options.target).scrollTop());
		}
	}
	pos.total = pos.current.top - pos.start;
}

function updateLastPos() {
	pos.previous.top = pos.current.top;
	pos.previous.bottom = pos.current.bottom;
}

function loop(type) {
	if (controller.loaded == true && lockScroll == false) {
		updatePos();
		if (type == false || typeof type == 'undefined') {
			var key;
			for (key in calculation) {
				calculation[key](pos);
			}
			for (key in animation) {
				animation[key](pos);
			}
		} else {
			calculation[type](pos);
			animation[type](pos);
		}
		updateLastPos();
	}
}

$.fn.scroller.loop = function() {
	loop();
	if (Modernizr.raf) {
		controller.RAF.ID = window.requestAnimationFrame($.fn.scroller.loop);
	}
};

$.fn.scroller.start = function() {
	if (!controller.RAF.ID && controller.loaded == true) {
		pos.total = 0;
		pos.start = Math.round($(options.target).scrollTop());
		$.fn.scroller.loop();
	}
};

$.fn.scroller.stop = function() {
	if (controller.RAF.ID) {
		 window.cancelAnimationFrame(controller.RAF.ID);
		 controller.RAF.ID = undefined;
	}
};

$.fn.scroller.resize = function(type) {
	if (controller.loaded == true) {
		controller.windowHeight = $(options.target).height();
		$.isFunction( options.resize ) && options.resize.call(controller.$this);
		if (type == false || typeof type == 'undefined') {
			for (var key in updateItems) {
				updateItems[key]();
			}
			loop();
		} else {
			updateItems[type]();
			loop(type);
		}
	}
};

this.init = function() {
	$(options.target).scroll(function() {
		if (Modernizr.raf) {
			clearTimeout($.data(this, 'timer'));
			if (controller.scrollTimer == false) {
				controller.scrollTimer = true;
				$.fn.scroller.start();
			}
			$.data(this, 'timer', setTimeout(function() {
				controller.scrollTimer = false;
				$.fn.scroller.stop();
			}, 100));
		} else {
			$.fn.scroller.loop();
		}
	});
	controller.windowHeight = $(options.target).height();
	getItems.default();
	controller.loaded = true;
	loop();
};
this.init();

$.fn.scroller.inview = function( opt ) {
	opt = $.extend({
		item : '.item',
		offset: {
			top: 0,
			bottom : 0,
		},
		change: function($item, callback) {},
		id : null
	}, opt);
	options.inview = true;
	getItems.inview(opt);
	loop('inview');
}

$.fn.scroller.anchors = function( opt ) {
	opt = $.extend({
		item : '.anchor',
		anchor : 'data-anchor',
		hash : true,
		offset: 100,
		change: function(hash, callback) {},
		id : null
	}, opt);
	options.anchors = true;
	getItems.anchors(opt);
	loop('anchors');
};

$.fn.scroller.sticky = function( opt ) {
	opt = $.extend({
		item : '#sitewide',
		mode : 'sitewide',
		cssClass : 'sticky',
		start : 500,
		resetToTop : 150,
		change: function($item, callback) {},
		id : null
	}, opt);
	options.sticky = true;
	getItems.sticky(opt);
	loop('sticky');
};

$.fn.scroller.updateItems = function(type, id, options) {
	for (var key in items[type]) {
		var $item = items[type][key];
		if ($item.options.id == id) {
			var opt = $.extend(
				$item.options
			, options);
			$item.options = opt;
			loop(type);
		}
	}
};

$.fn.scroller.lockScroll = function(lock) {
	if (lock == true) {
		lockScroll = true;
	} else {
		lockScroll = false;
	}
};

};
